export enum KinshipType {
  PADRE = 'PADRE',
  MADRE = 'MADRE',
  FUTURA_MADRE = 'FUTURA_MADRE',
  FUTURO_PADRE = 'FUTURO_PADRE'
}

export interface ExamTypeInfo {
  examGroupName: string | null;
  requiredRelatives: number | null;
  isTrio: boolean;
  isDuo: boolean;
  isFuturosPadres: boolean;
  requiresFamilyMembers: boolean;
}

export interface FamilyMemberData {
  tipoParentesco: KinshipType;
  datosPaciente: {
    idNumber: string;
    identifierTypeCode: string;
    patientNumber?: string;
    givenName: string;
    middleName?: string;
    familyName: string;
    maternalFamilyName?: string;
    emailAddress?: string;
    birthDate: string;
    administrativeSex: string;
    maritalStatus?: string;
    race?: string;
    telephoneNumber?: string;
    streetAddress?: string;
    city: string;
    state: string;
    country: string;
  };
  datosMuestra?: {
    specimenId?: string;
    specimenTypeId?: string;
    specimenContainerId?: string;
  };
}

export interface ManualEntryWithFamilyPayload {
  datosPaciente: {
    idNumber: string;
    identifierTypeCode: string;
    patientNumber?: string;
    givenName: string;
    middleName?: string;
    familyName: string;
    maternalFamilyName?: string;
    emailAddress?: string;
    birthDate: string;
    administrativeSex: string;
    maritalStatus?: string;
    race?: string;
    telephoneNumber?: string;
    streetAddress?: string;
    city: string;
    state: string;
    country: string;
  };
  datosMuestra: {
    specimenId: string;
    specimenTypeId: string;
    specimenContainerId?: string;
    priorityId: string;
    reprocess: boolean;
  };
  datosExamen: {
    examId: string;
  };
  datosOrden: {
    companyId?: string;
    providerId?: string;
    regionalId: string;
    siteId: string;
    placerOrderNumber: string;
    caseNumber?: string;
    consentForUseOfSamples: boolean;
    userDataDescription?: string;
    descriptionDataSample?: string;
    descriptionDataExam?: string;
    clinicalHistory?: string;
    prioritization: boolean;
    acmg: boolean;
    mlpa: boolean;
    laboratoryId: string;
    diagnosisId: string;
    specialistId?: string;
  };
  datosReproceso?: {
    reprocessStatusId?: string;
    reprocessCauseId?: string;
    reprocessObservation?: string;
  };
  familiares?: FamilyMemberData[];
}

export interface FamilyMemberInfo {
  orderId: string;
  lgNumber: string;
  kinshipType: KinshipType;
  patientName: string;
  idNumber: string;
}

export interface ManualEntryWithFamilyResponse {
  message: string;
  affected: {
    orderId: string;
    lgNumber: string;
    caseNumber: string;
    patientName: string;
    idNumber: string;
  };
  familyMembers: FamilyMemberInfo[];
}
